import { useEffect, useState } from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";
import { getCoordinadoresDeEquipoRoles, getEtapas, putEquipo } from "../../controllers/org";
import { profileTypes } from "../../controllers/profiles";
import { Typeahead } from "react-bootstrap-typeahead";

function ComunidadCrearEquipo({ comunidadId, miembros, ciclo, equipos, onSuccess, etapaId, coordinadorId }) {
  const [etapa, setEtapa] = useState(NaN);
  const [etapas, setEtapas] = useState([]);
  const [coordinador, setCoordinador] = useState([]);
  const [equiperos, setEquiperos] = useState([]);
  const [coordinadoresDeEquipoRoles, setCoordinadoresDeEquipoRoles] = useState([]);
  const [coordinadoresOptions, setCoordinadoresOptions] = useState([]);
  const [equiperosOptions, setEquiperosOptions] = useState([]);
  const [alert, setAlert] = useState();
  let usedProfileTypes = {};

  useEffect(() => {
    loadEtapas();
    loadCoordinadoresDeEquipoRoles();
  }, []);

  useEffect(() => {
    const et = etapas.filter(e => e.etapa_id === etapa)[0];
    let cOptions = [];
    let eOptions = [];
    if (et) {
      miembros.forEach(m => {
        let foundInTeam = false;
        equipos.forEach(equipo => {
          if (equipo.team_members.find(tm => tm.membership_id === m.membership_id)) {
            foundInTeam = true;
          }
        });
        if (!foundInTeam && m.profile_type_id === et.type && m.etapa_id === etapa) {
          if (m.membership_roles.find(mr => mr.role_id === coordinadoresDeEquipoRoles[et.type])) {
            cOptions.push(m);   
          }
          else {
            eOptions.push(m);
          }
        }
      });
    }
    if (coordinadorId) {
      cOptions = miembros.filter(m => m.membership_id === coordinadorId);
      setCoordinador(cOptions);
    }
    else {
      setCoordinador([]);
    }
    setCoordinadoresOptions(cOptions);
    setEquiperosOptions(eOptions);
    setEquiperos([]);
  }, [etapa, miembros]);

  async function loadEtapas() {
    let r = await getEtapas();
    miembros.forEach(m => {
      if (!usedProfileTypes[m.profile_type_id] && m.profile_type_id !== profileTypes.ASESOR) {
        usedProfileTypes[m.profile_type_id] = parseInt(m.profile_type_id);
      }
    });
    r = r.filter(etapa => Object.values(usedProfileTypes).includes(etapa.type));
    setEtapas(r);
    if (etapaId) {
      setEtapa(etapaId);
    }
  }

  async function loadCoordinadoresDeEquipoRoles() {
    let r = await getCoordinadoresDeEquipoRoles();
    setCoordinadoresDeEquipoRoles(r);
  }

  function renderEtapas() {
    return etapas.map(etapa => {
      return <option value={etapa.etapa_id} key={'crear-equipo-etapa-option-' + etapa.etapa_id}>
        {etapa.type === profileTypes.MATRIMONIO ? 'Matrimonios' : 'Mamás'} - {etapa.title}
      </option>;
    })
  }


  async function handleSubmit(e) {
    e.preventDefault();
    try {
        let r = await putEquipo(
          ciclo,
          comunidadId,
          etapa,
          coordinador.concat(equiperos)
        );
        setAlert(<Alert variant="success">Se creó el equipo correctamente.</Alert>);
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(r.team_id);
        }
        setEtapa(NaN);
        setCoordinador([]);
        setEquiperos([]);
    }
    catch (e) {
      setAlert(<Alert variant="warning">Ocurrió un error al crear el equipo. Intenta de nuevo más tarde.</Alert>);
    }
  };

  let submitButton;

  if (etapa !== 'null' && coordinador.length && equiperos.length) {
    submitButton = <Form.Group className="mb-3 submit-buttons-wrapper">
      <Button key='submit-btn-new-equipo' type='submit' variant='primary' onClick={handleSubmit}>Crear equipo</Button>
    </Form.Group>;
  }

  console.log('etapa: ' + etapa);
  return <Card style={{paddingBottom: '10rem'}}>
    <Card.Header>Crear Equipo</Card.Header>
    <Card.Body style={{overflow: 'visible'}}>
      {alert}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nivel</Form.Label>
          <Form.Select onChange={e => setEtapa(parseInt(e.target.value))} value={etapa} disabled={!!etapaId}>
            <option value={'null'}>-- Selecciona un nivel --</option>
            {renderEtapas()}
          </Form.Select>
        </Form.Group>

        {!isNaN(etapa) && !!coordinadoresOptions.length && <Form.Group className="mb-3">
          <Form.Label>Coordinador</Form.Label>
          <Typeahead
            id="coordinador"
            name="coordinador"
            labelKey="label"
            onChange={(selected) => {
              setCoordinador(selected);
            }}
            options={coordinadoresOptions}
            placeholder="Selecciona un matrimonio coordinador"
            renderMenuItemChildren={(option) => (
                <span>{option.label}</span>
            )}
            selected={coordinador}
            disabled={!!coordinadorId}
          />
        </Form.Group>}
        {!isNaN(etapa) && !coordinadoresOptions.length && <Alert variant="danger">No hay miembros que sean coordinadores de este nivel sin equipo.</Alert>}
        {!isNaN(etapa) && !equiperosOptions.length && <Alert variant="danger">No hay miembros en este nivel sin equipo.</Alert>}

        {!isNaN(etapa) && !!coordinador.length && !!equiperosOptions.length && <Form.Group className="mb-3">
          <Form.Label>Equiperos</Form.Label>
          <Typeahead
            id="equiperos"
            labelKey="label"
            onChange={(selected) => {
              setEquiperos(selected);
            }}
            options={equiperosOptions}
            placeholder="Selecciona a los equiperos"
            renderMenuItemChildren={(option) => (
                <span>{option.label}</span>
            )}
            selected={equiperos}
            multiple={true}
          />
        </Form.Group>}

        { submitButton }
      </Form>
    </Card.Body>
  </Card>;;
}

export default ComunidadCrearEquipo;